import { Component } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import numeral from 'numeral';
import 'numeral/locales/it';

numeral.locale('it');

class InputComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      inputFocus: false,
    };

    this.onBlurHandler = this.onBlurHandler.bind(this);
    this.onChangeHandler = this.onChangeHandler.bind(this);
    this.onFocusHandler = this.onFocusHandler.bind(this);
  }

  onChangeHandler(e) {
    /* Convert formatted text to numeric */
    const value = e.target.value;
    let leadingZerosStrippedValue;
    let leadingZerosStrippedEvent = {};

    // eslint-disable-next-line eqeqeq
    if (Number(value) !== 0) {
      leadingZerosStrippedValue = value.replace(/[^0-9.]/g, '');
      leadingZerosStrippedValue = leadingZerosStrippedValue.replace(/^0+/, '');
      leadingZerosStrippedEvent = { ...e };
      leadingZerosStrippedEvent.target.value = leadingZerosStrippedValue;
    }

    this.props.onChangeHandler(leadingZerosStrippedValue || value);
    const event = _.isEmpty(leadingZerosStrippedEvent) ? e : leadingZerosStrippedEvent;
    this.props.onChange(event);
  }

  onBlurHandler(e) {
    this.setState({ inputFocus: false });
    const value = Number(e.target.value);
    this.props.onBlurHandler(value);
  }

  onFocusHandler(e) {
    this.setState({ inputFocus: true });

    const value = e.target.value;
    this.props.onFocusHandler(value);
  }

  render() {
    const {
      name,
      placeholder,
      value,
      classNames,
      label,
      currency } = this.props;

    let input;
    /* If currency is true, show € prefix. */
    if (currency) {
      const currencyInput = this.state.inputFocus ? value.toString() : numeral(value).format('0,0[.]00');

      input = (
        <div className="inputField_currency">
          <input
            ref={(textInput) => { this.textInput = textInput; }}
            type="text"
            value={currencyInput}
            name={name}
            placeholder={placeholder}
            onBlur={this.onBlurHandler}
            onFocus={this.onFocusHandler}
            onChange={this.onChangeHandler}
            className="inputField_input"
          />
        </div>
    );
    } else if (!currency) {
      input = (
        <input
          ref={(textInput) => { this.textInput = textInput; }}
          value={value}
          type="text"
          name={name}
          placeholder={placeholder}
          onBlur={this.onBlurHandler}
          onChange={this.onChangeHandler}
          className="inputField_input"
        />
      );
    }

    return (
      /* Classnames are dynamic. Used for responsive styling. */
      <div className={classNames}>
        <div className="formField inputField selectField">
          <label className="formField_label inputField_label required" htmlFor={this.textInput}>{label}</label>
          {input}
          {this.props.children}
        </div>
      </div>
    );
  }
}

InputComponent.propTypes = {
  children: PropTypes.node,
  name: PropTypes.string,
  currency: PropTypes.bool,
  classNames: PropTypes.string,
  placeholder: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  onChange: PropTypes.func,
  onChangeHandler: PropTypes.func,
  onBlurHandler: PropTypes.func,
  onFocusHandler: PropTypes.func,
};

InputComponent.defaultProps = {
  children: '',
  name: '',
  currency: false,
  classNames: '',
  placeholder: '',
  label: '',
  value: '',
  onChange: () => {},
  onChangeHandler: () => {},
  onBlurHandler: () => {},
  onFocusHandler: () => {},
};

export default InputComponent;
